var ContentService = require('services/content-service');
import CustomPageService from 'services/custom-page-service';
var LocaleService = require('services/locale-service');
var Utils = require('lib/utils');
var SurveyService = require('services/survey-service');
var EvaluationService = require('services/evaluation-service');
var AssessmentService = require('services/assessment-service');
var CourseSettingsService = require('services/course-settings-service');
import LearnerProfileService from 'services/learner-profile-service';

//TODO: do we need a base service class?
var PageService = {
  loadPage: function(moduleKey, activityKey, pageKey) {
    //TODO: figure out when to 'unload' the current page
    var pagePresent = pageKey !== undefined && pageKey !== null && pageKey !== '';
    var activityPresent = activityKey !== undefined && activityKey !== null && activityKey !== '';

    if(!EF.module || moduleKey != EF.module.get('key')) {
      EF.setModuleByKey(moduleKey);
      LocaleService.setModuleResources(moduleKey);
    }

    if(!EF.module.currentActivity || activityKey != EF.module.currentActivity.get('key')) {
      if(activityPresent) {
        EF.module.setActivityByKey(activityKey);
      } else {
        EF.module.getStartingActivity();
      }
      if(!EF.module.currentActivity) {
        EF.module.currentActivity = EF.module.activities.head();
      }
      if(EF.module.currentActivity.isComplete()) {
        EF.module.currentActivity.set('redo', true);
      }
    }

    if(!EF.module.currentActivity.currentPage || pageKey != EF.module.currentActivity.currentPage.get('key')) {
      if(pagePresent) {
        EF.module.currentActivity.setPageByKey(pageKey);
      } else {
        EF.module.currentActivity.getStartingPage();
      }
      if(!EF.module.currentActivity.currentPage) {
        EF.module.currentActivity.currentPage = EF.module.currentActivity.pages.head();
      }
      //TODO: check why progress was being set during page load
    }
    ContentService.addForgePathsToContentRegion(".before-content", ContentService.moduleContent.modules);
    //TODO: should we use the content service here instead of in the page controller?
    return ContentService.applyPageContent(EF.module.currentActivity.currentPage);
  },
  getNextPage: function() {
    //TODO: this method uses the autoNextActivity option, do we need an autoNextModule option?
    //      specifically thinking about the NHL course which may have multiple modules in a 'group'
    return EF.module.getNextPageByKey(EF.module.currentActivity.currentPage.get('key'));
  },

  getPageByKey: function(key) {
    var activity = {};
    if(key.indexOf('/') > -1) {
      var split = key.split('/');
      if(split.length > 2) {
        var moduleName = split[0];
        var module = EF.modules.find((m) => {
          return m.get('key') == moduleName;
        });
        var activityName = split[1];
        activity = module.activities.find((acc) => {
          return acc.get('key') == activityName;
        });
        key = split[2];
      }
      else 
      {   
        activityName = split[0];
        activity = EF.module.activities.find((acc) => {
          return acc.get('key') == activityName;
        });
        key = split[1];
      }
    } else {
      activity = EF.module.currentActivity;
    }
    return activity.pages.find(function(page) {
      return page.get('key') === key;
    });
  },

  getPreviousPage: function() {
    return EF.module.getPreviousPageByKey(EF.module.currentActivity.currentPage.get('key'));
  },

  shouldPreventPageSkipping: function() {
    return CourseSettingsService.get('preventPageSkipping') !== undefined ? Boolean(CourseSettingsService.get('preventPageSkipping')) : true;
  },

  preventSkippingPages: function(page, params) {
    let localSkipping = EF.options.local ? EF.options.pageSkipping : false;
    if(params.page && !localSkipping && !EF.enrollment.get('demoMode') && !EF.module.isComplete() && this.shouldPreventPageSkipping()) {
      // prevent skipping incomplete pages
      let lastCompleted = EF.module.currentActivity.pages.lastCompleted();
      let key   = lastCompleted.get('key');
      let next  = EF.module.currentActivity.nextPageByKey(key);
      while(next && next.get('optional')) {
        next = EF.module.currentActivity.nextPageByKey(next.get('key'));
      }
      if(next && page.get('index') > next.get('index')) {
        Utils.redirectToPage(lastCompleted);
        return false;
      }
    }
    return true;
  },
  shouldSkipLearner: function(skipJSON) {
    // Allow for specifying page-skipping based on parameters in the learner_profile
    //
    // Usage Example:
    // # Hide the page for Corporate users AND users in either Alaska OR California
    // skip:
    //   learner_profile:
    //     - key: learner_location_iso_code
    //       show:
    //         - US-AK
    //         - US-CA
    //     - key: org_type
    //       hide:
    //         - CO
    if(!skipJSON.learner_profile){
      return false;
    }
    return skipJSON.learner_profile.map(criteria => {
      var hidden = ((hide) => {
        if(hide && Array.isArray(hide)) {
          return hide.map(criterion => LearnerProfileService.get(criteria.key) === criterion);
        } else {
          return [ false ];
        }
      })(criteria.hide).some(i => i);
      var shown = ((show) => {
        if(show && Array.isArray(show)) {
          return show.map(criterion => LearnerProfileService.get(criteria.key) === criterion);
        } else {
          return [ true ];
        }
      })(criteria.show).some(i => i);
      return hidden || !shown;
    }).find(i => i);
  },
  shouldBeSkipped: function(page) {
    var skipCallback = page.script.skip;
    var skipJSON = page.model.get('skip');

    var evaluationShouldBeSkipped = EvaluationService.shouldSkip();

    if(skipCallback) {
      return skipCallback(page);
    } else if(skipJSON) {
      let customizationAbsent;

      if(skipJSON.customization) {
        const { module, activity, page } = CustomPageService.modulePaths();
        customizationAbsent = !CustomPageService.hasPageCustomization(skipJSON.slug, module, activity, page) && EF.customizations.getByKeyAndSlug(skipJSON.customization, skipJSON.slug) === undefined;
      } else if(skipJSON.resource_type) {
        customizationAbsent = EF.resources.byTypeSync(skipJSON.resource_type, skipJSON.resource_sub_type).length === 0;
      } else if(skipJSON.survey_slug) {
        customizationAbsent = SurveyService.userHasCompletedSurvey(skipJSON.survey_slug) || evaluationShouldBeSkipped;
      } else if(skipJSON.assessment_slug) {
        customizationAbsent = AssessmentService.userHasCompletedAssessment(skipJSON.assessment_slug) || evaluationShouldBeSkipped;
      } else if(skipJSON.learner_profile) {
        customizationAbsent = this.shouldSkipLearner(skipJSON)
      }
      return skipJSON.when === 'present' ? !customizationAbsent : customizationAbsent;
    }
  },
  setPageOptional: function(page) {
    var currentPage = EF.module.currentActivity.currentPage;

    EF.module.currentActivity.pages.each((p) => {
      if (p.get('index') >= currentPage.get('index') && p.get('index') <= page.get('index')){
        page.set('optional', true)
      }
    })
  },
  setScrollToElement: function($element, $scrollPane, scroll = 'y') {
    if($element && $scrollPane) {
      setTimeout(() => {
        // As of now it only supports 'vertical scroll',
        // TODO: Can be extended to support 'horizontal scroll' as when will be required
        if(scroll === 'y') {
          $scrollPane.animate({
              scrollTop: this.getElementScrollPos($element, $scrollPane)
            }, 500
          );
        }
      }, 500);
    }
  },
  getElementScrollPos: function($element, $scrollPane, scroll = 'y') {
    let scrollPos = 0;

    if($element && $scrollPane) {
      const $siteContainer = $('#site-container');
      // As of now it only returns 'vertical scroll position' for '$element',
      // TODO: Can be extended to return 'horizontal scroll position' for '$element' as when will be required
      if(scroll === 'y') {
        const $siteContainerPosY = $siteContainer.offset().top - parseInt($siteContainer.css('margin-top').replace('px', ''));
        const scrollPaneBoundingClientRectTop = $scrollPane.selector === 'html, body' ? $siteContainerPosY : $scrollPane.get(0).getBoundingClientRect().top;
        const scrollPaneScrollTop = $scrollPane.scrollTop();
        const elementBoundingClientRectTop = $element
          .get(0)
          .getBoundingClientRect().top;

        scrollPos = (elementBoundingClientRectTop - scrollPaneBoundingClientRectTop + scrollPaneScrollTop);
      }
    }

    return scrollPos;
  }
};

module.exports = PageService;
